import { ThemeUIStyleObject } from 'theme-ui';

export const headerContainerStyles: ThemeUIStyleObject = {
  bg: 'neutral/000', // White background using theme token
  borderBottom: '1px solid',
  borderColor: 'neutral/300', // Light gray border using theme token
  px: ['1rem', '5rem'], // mobile, desktop
  height: ['3.5rem', '4rem'], // Slightly shorter on mobile
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  position: 'sticky',
  top: 0,
  zIndex: 100,
};

export const leftSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: ['1rem', '2rem'], // mobile, desktop
  flex: 1,
};

export const rightSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: ['0.5rem', '1rem'], // mobile, desktop - tighter on mobile
};
